var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stone_een",
    d: "M5,15H4c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h1V15z M21,11H11v3h10V11z M23,10v5 c0,0.551-0.449,1-1,1H10c-0.551,0-1-0.449-1-1v-5c0-0.551,0.449-1,1-1h12C22.551,9,23,9.449,23,10z M22,10H10v5h12V10z M26,18.02 c0,1.317-0.13,2.631-0.388,3.922l-1.129,5.646C24.202,28.991,22.971,30,21.541,30H10.459c-1.43,0-2.661-1.009-2.942-2.412 l-1.129-5.646C6.13,20.65,6,19.337,6,18.02V7c0-2.761,2.239-5,5-5h10c2.761,0,5,2.239,5,5V18.02z M24,10c0-1.103-0.897-2-2-2H10 c-1.103,0-2,0.897-2,2v5c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2V10z M28,10h-1v5h1c0.552,0,1-0.448,1-1v-3 C29,10.448,28.552,10,28,10z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeld);
export default __webpack_public_path__ + "static/media/weld.16aae9a50899f290dee3a3f4a6e789e1.svg";
export { ForwardRef as ReactComponent };